import { apiRequest } from "./apiRequest";
import { errorHandler } from "./errorHandler";
import { GroupedVariants } from "../interface/variant";

export const getVariants = async (
  productId: number
): Promise<GroupedVariants[]> => {
  if (Number.isNaN(productId)) {
    throw new Error("Invalid productId: Not a number");
  }

  try {
    return await apiRequest<GroupedVariants[]>(
      "get",
      `/products/variant/${productId}`
    );
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to fetch variants");
  }
};